<template>
  <base-tile
    :title="$t('organizations.info')"
    i18nPrefix="organizations"
    :rows="state.rows"
  >
    <!-- ID -->
    <template #[state.readOrganizationIdSlot]>
      <td v-if="state.id" class="p-2">
        <span>{{ state.id }} </span>
        <button-clipboard-copy
          :field="$t('organizations.id')"
          :value="state.id"
        />
      </td>
    </template>

    <!-- NAME -->
    <template #[state.readOrganizationNameSlot]>
      <td v-if="store.state.identity.organization.name" class="p-2">
        <span>{{ store.state.identity.organization.name }} </span>
        <va-button
          v-if="canUserEdit"
          flat
          size="small"
          icon="create"
          @click="emit('editName')"
        />
      </td>
    </template>

    <!-- PARTNER -->
    <template #[state.readOrganizationPartnerSlot]>
      <td class="p-2">
        <span>{{ partnerLabel }} </span>
        <va-button
          v-if="canUserEdit"
          flat
          size="small"
          icon="create"
          @click="emit('editPartner')"
        />
      </td>
    </template>
  </base-tile>
</template>

<script setup>
import { computed, reactive } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import BaseTile from "@/components/BaseTile.vue";
import ButtonClipboardCopy from "@/components/ButtonClipboardCopy.vue";
import { printDate } from "@/utils";

const { t } = useI18n();
const store = useStore();

const emit = defineEmits(["editName", "editPartner"]);

const canUserEdit = computed(
  () =>
    store.state.auth.hasGlobalAccess ||
    store.state.auth.permissions.includes("update:organization")
);

/** IdentityHub's `isPartner`: its invitations lead to the Partner Portal. */
const isPartner = computed(
  () => store.state.identity.organization.isPartner === true
);

const partnerLabel = computed(() =>
  isPartner.value ? t("general.yes") : t("general.no")
);

const state = reactive({
  id: store.state.identity.organization.id,
  name: store.state.identity.organization.name,
  createdAt: store.state.identity.organization.createdAt,
  rows: computed(() => {
    const organization = store.state.identity.organization;
    return [
      {
        label: t("organizations.id"),
        value: organization.id
      },
      {
        label: t("organizations.name"),
        value: organization.name
      },
      {
        label: t("organizations.createdAt"),
        value: printDate(organization.createdAt)
      },
      {
        label: t("organizations.isPartner"),
        value: partnerLabel.value
      }
    ];
  }),
  readOrganizationIdSlot: `${t("organizations.id")}-value`,
  readOrganizationNameSlot: `${t("organizations.name")}-value`,
  readOrganizationPartnerSlot: `${t("organizations.isPartner")}-value`
});
</script>
